import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer__logo">
        <div className="footer__logo--mobile">
          <Logo type="icon" className="footer__logo-image" />
        </div>
        <div className="footer__logo--desktop">
          <Logo className="footer__logo-image" type="icon" />
        </div>
      </div>
      
      <p className="footer__legal-links">
        <NavLink className="text-link" to="/subpage/terms-of-service">
          {t('nav.termsOfService', 'Terms of Service')}
        </NavLink>{' '}
        
        <NavLink
          className="text-link"
          to="/subpage/privacy-and-confidentiality"
        >
          {t('nav.privacy')}
        </NavLink>
      </p>

      <p className="footer__note">
        {t('nav.copyright').replace('2019', new Date().getFullYear())}
      </p>
    </footer>
  );
};

Footer.propTypes = {
  isAuthenticated: PropTypes.bool,
  isAdmin: PropTypes.bool,
  handleLogout: PropTypes.func,
  onInviteClick: PropTypes.func,
  location: PropTypes.object
};

export default Footer;
